import { render, staticRenderFns } from "./RenegociacaoMenu.vue?vue&type=template&id=13f40566&scoped=true&"
import script from "./RenegociacaoMenu.vue?vue&type=script&lang=js&"
export * from "./RenegociacaoMenu.vue?vue&type=script&lang=js&"
import style0 from "./RenegociacaoMenu.vue?vue&type=style&index=0&id=13f40566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f40566",
  null
  
)

export default component.exports